import axios from 'axios';

// const mailBaseURL = 'http://api.iceverg.local:8082/';
const mailBaseURL = 'https://api.iceverg.com/';
const MailAPI = axios.create({
  baseURL: mailBaseURL
});

const contacts = {
  sendContact: (payload) => MailAPI.post('/contacts', payload)
};

export default {
  contacts
};
